import React from 'react';
import './styles.css';
import { useHistory } from 'react-router';
import { Button, Row, Col } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowCircleDown } from '@fortawesome/free-solid-svg-icons';
import ResultsImage from '@BUP/assets/Images/Data/data-19.png';
import { ButtonBackData, DividerContainer, PageLayout } from '@BUP/components';
import { useBraveUpSurveysApi, useGetReports } from '@BUP/hooks';

const DataResultsReportPage = () => {
  const history = useHistory();
  const { survey } = useBraveUpSurveysApi();
  const { report } = useGetReports(survey);
  const [report1] = report;
  // console.log('ReportUrl', report1?.url);

  return (
    <PageLayout>
      <ButtonBackData onClick={() => history.goBack()} />
      <DividerContainer title="REPORTE DE RESULTADOS" />
      <p className="reportResults_paragraph">
        ¡Los resultados del Diagnóstico de Convivencia Escolar ya están
        disponibles para que los descargues!
      </p>
      <p className="reportResults_paragraph">
        Acá encontrarás los principales hallazgos de los cuatro estamentos, por
        lo que recomendamos que te tomes todo el tiempo que sea necesario para
        revisarlo en detalle. No te olvides de compartir este material con el
        resto de tu equipo para que puedan planificar las acciones a implementar
        en base a las evidencias recopiladas.
      </p>
      <Row className="reportResults_row">
        <Row align="center">
          <Col span={14}>
            <img src={ResultsImage} style={{ width: '100%' }} alt="" />
          </Col>
        </Row>
        <Col span={24} align="center">
          <Button className="resultsReport_button__download-results">
            <a target="_blank" href={report1?.url} rel="noreferrer">
              Descarga el <br />
              reporte de resultados
            </a>
          </Button>
          <FontAwesomeIcon
            className="resultsReport_download-icon"
            icon={faArrowCircleDown}
          />
        </Col>
      </Row>
    </PageLayout>
  );
};

export default DataResultsReportPage;
